export const zhCnLocale = {
  model: {
    category: '分类'
  },
  category: {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    title: '标题',
    parentId: 'Parent',
    position: '优先级',
    image: '图片',
    children: 'Children',
    parent: '上一级分类',
  }
}

export const enLocale = {
  model: {
    category: 'Category'
  },
  category: {
    id: 'ID',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    title: 'Title',
    parentId: 'Parent',
    position: 'Position',
    image: 'Image',
    children: 'Children',
    parent: 'Upper Category',
  }
}

